import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import type { PageKey } from "../../types/pages";

interface RequirePageAccessProps {
  page: PageKey;
  children: ReactNode;
}

/**
 * Guards a route by page-level access.
 * - super-admin always passes.
 * - normal_user passes only if their assigned role grants this page.
 */
export function RequirePageAccess({ page, children }: RequirePageAccessProps) {
  const { user, hasPageAccess } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPageAccess(page)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
